module.exports = __webpack_public_path__ + "static/media/orangeTheme-girl.be9c6f56.svg";